(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ht-opening-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.getElementById('ht-drop');
    if (!root || /^\/(cart|checkout|checkouts|account|challenge)(\/|$)/.test(location.pathname)) return;
    const preview = new URLSearchParams(location.search).get('ht_pass_preview') === '1';
    if (window.Shopify?.designMode && !preview) return;
    const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
    const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
    const pending = (() => { try { return Date.now() - Number(sessionStorage.getItem('ht-pass-pending') || 0) < 1800000; } catch { return false; } })();
    const success = pending && !!root.querySelector('[data-drop-success]');
    const errors = pending && !!root.querySelector('[data-drop-errors]');
    let timer;
    let readyAt = Infinity;
    let engaged = /^\/(products|collections)\//.test(location.pathname);
    const autoRequested = success || errors || preview;
    const eligible = () => {
      if (read('hiddenTerpsAgeAccepted') !== 'yes') return false;
      if (document.getElementById('age-check-hidden-terps')?.classList.contains('show')) return false;
      if (success || errors || preview) return true;
      if (root.dataset.subscriber === 'true' || read('ht-pass-subscribed') === 'yes') return false;
      return Date.now() - Number(read('ht-drop-dismissed') || 0) >= 604800000;
    };
    const show = () => {
      if (!eligible() || root.open) return;
      if (!autoRequested && (!engaged || Date.now() < readyAt)) return;
      const focused = document.activeElement;
      if (!autoRequested && (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || focused?.matches('input, textarea, select, [contenteditable="true"]'))) {
        timer = setTimeout(show, 5000);
        return;
      }
      if (success) {
        root.querySelector('.ht-drop__signup').hidden = true;
        root.querySelector('.ht-drop__success').hidden = false;
        write('ht-pass-subscribed', 'yes');
        try { sessionStorage.removeItem('ht-pass-pending'); } catch {}
      }
      root.showModal();
      document.body.classList.add('ht-drop-lock');
    };
    const schedule = () => { clearTimeout(timer); readyAt = Date.now() + (autoRequested ? 200 : 25000); timer = setTimeout(show, autoRequested ? 200 : 25000); };
    window.addEventListener('scroll', () => {
      const distance = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (window.scrollY / distance >= .25) { engaged = true; show(); }
    }, { passive: true });
    root.querySelector('[data-drop-close]').addEventListener('click', () => root.close());
    root.addEventListener('close', () => {
      document.body.classList.remove('ht-drop-lock');
      if (!success && !errors && !preview) write('ht-drop-dismissed', String(Date.now()));
    });
    root.addEventListener('click', event => {
      if (event.target !== root) return;
      const rect = root.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) root.close();
    });
    root.querySelector('form').addEventListener('submit', () => {
      try { sessionStorage.setItem('ht-pass-pending', String(Date.now())); } catch {}
    });
    root.querySelector('[data-drop-copy]')?.addEventListener('click', async event => {
      const button = event.currentTarget;
      try {
        await navigator.clipboard.writeText('WELCOME10');
        button.textContent = button.dataset.copied;
      } catch {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(root.querySelector('.ht-drop__code strong'));
        selection.removeAllRanges(); selection.addRange(range);
      }
    });
    document.addEventListener('ht:age-accepted', schedule);
    if (read('hiddenTerpsAgeAccepted') === 'yes') schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
